//
//
//
//
//

import global from '../../../static/js/global.js'
export default{
	data(){
		return {
			code:'',
			state:'',
			messageWarn:'',
			temp:''
		}
	},
	mounted: function(){
	  	this.code = this.$router.history.current.query.code;
		this.state = this.$router.history.current.query.state;
		let url = '';
		if(this.state == 0){
			url = global.host + 'users/getuserid?code='+this.code
		}else if(this.state == 1){
			url = global.host + 'users/getuser?code='+this.code + '&state=' + this.state + "&corpid=" + global.wechat.corpid + "&corpsecret=" + global.wechat.corpsecret;
		}
		if(url){
			this.$http.get(url).then(function(res){
				if(res.body.success){
					if(res.body.result.state == 'banding'){
					  //muId代表从日常缴费进去绑定房屋
						this.$router.replace({path:'/houseBind',query:{openid:res.body.result.list[0].openId,phone:res.body.result.list[0].mainPhone,IsDefault:1,muId:3}})
					}else if(res.body.result.state == 'login'){
						console.log(res)
						this.$router.replace({path:'/pay/tenement',query:{openid:res.body.result.openId,phone:res.body.result.mainPhone}})
					}else{
						if(res.body.statusCode == '120'){
							/*异常信息*/
							this.messageWarn = '获取openId异常，请联系管理员';
						}else{
							/*用户不存在，需要注册*/
							this.$router.replace({path:'/register',query:{openid:res.body.result.openId,nickname:res.body.result.nickname,headerimgurl:res.body.result.headimgurl}})
						}
					}
				} else {
          this.$router.replace({path:'/register',query:{openid:res.body.result.openId,nickname:res.body.result.nickname,headerimgurl:res.body.result.headimgurl}})
          // this.$router.replace({path:'/register',query:{openid:res.body.statusCode,nickname:JSON.parse(res.body.message).nickname,headerimgurl:JSON.parse(res.body.message).headimgurl}})
				}
			},function(err){
        /*异常信息*/
				console.log(err);
        this.messageWarn = err;
			})
		}
	},
	methods:{
		iterator(obj){
			let str = '';
			for (let prop of obj ){
				if(typeof obj[prop] === 'object'){
					continue
				}else if(typeof obj[prop] === 'function'){
					continue
				}else{
					str = str + prop + ':' + obj[prop];
				}
			}
			return str;
		}
	}
}



// WEBPACK FOOTER //
// ./src/components/beforelogin/dayPay.vue